import { useEffect, useState } from 'react';
import { useStore } from '../../lib/hooks/useStore';
import GenericButton from '../button-generic';
import style from './style.module.scss';
import LanguageCode from '../../lib/types/language';
import { getNativeLanguageName } from '../../lib/constants/nativeLanguageNames';
import logger from '../../lib/helpers/logger';

export default function LanguageSelect({
	languages,
	handleNavigation,
	...props
}: {
	languages?: string[] | null | undefined;
	handleNavigation: (pageId: string) => void;
}) {
	const {
		configStore: { changeLanguage },
		sessionStore: { startLoggingSessionData },
		uiStore: { showLoader, hideLoader },
	} = useStore();
	const [isLoading] = useState(false);
	const [classList, setClassList] = useState<string[]>([]);

	const selectLanguage = async (language: LanguageCode) => {
		try {
			showLoader();
			await changeLanguage(language);
			logger.logTranslation.log({ language: language }, `Selected language "${language}"`);
		} catch (error) {
			logger.logGeneral.error({}, `Error changing language to "${language}"`, error);
		} finally {
			hideLoader();
			handleNavigation('terms-and-conditions');
		}
	};

	useEffect(() => {
		if (languages && languages?.length > 6) setClassList([style['language-select'], style['language-select--above-6-items']]);
		else setClassList([style['language-select--below-6-items'], style['language-select']]);
	}, [languages]);

	if (isLoading) {
		return <></>;
	} else if (languages && languages.length > 0) {
		return (
			<div className={classList.join(' ')} {...props}>
				{languages &&
					languages.map((language, idx) => {
						const displayName = getNativeLanguageName(language);
						return (
							<GenericButton
								className={style['language-select__button']}
								innerText={displayName}
								key={idx}
								onClick={() => {
									startLoggingSessionData();
									selectLanguage(language as LanguageCode);
								}}
							/>
						);
					})}
			</div>
		);
	} else {
		return <>No languages configured...</>;
	}
}
